export class GeneralLeadershipPage {

    constructor() {

        //document.ready
        $(() => {

            $('#tabSelect').change(function () {
                const requestedTab = $(this).val();
                $('#' + requestedTab+'Tab').tab('show');
            });

            // const hash = window.location.hash;
            // if (hash) {
            //     $(hash + 'Tab').tab('show');
            // }

        });

    }

}